import Grid from '@mui/material/Grid'

interface Props {
  changed: boolean
  handleSave: () => void
  handleCancel: () => void
  saveDisabled?: boolean
}

const ControlButtons = ({ changed, handleSave, handleCancel, saveDisabled }: Props): JSX.Element | null => changed
  ? (
    <Grid container spacing={2} className='mv6'>
      <Grid item>
        <SaveButton {...{ handleSave, saveDisabled }} />
      </Grid>
      <Grid item>
        <CancelButton {...{ handleCancel }} />
      </Grid>
    </Grid>
    )
  : null

const SaveButton = ({ handleSave, saveDisabled }: Pick<Props, 'handleSave' | 'saveDisabled'>): JSX.Element => (
  <a
    className={`pv3 ph8 ba b--transparent br2 normal f6 lh-copy-variant ${saveDisabled === true ? 'o-50 not-allowed bg-teal white' : 'bg-teal white hover-white hover-o-90 pointer'}`}
    href={undefined}
    data-event-category='Account'
    data-event-action='Preferences save'
    onClick={() => saveDisabled !== true && handleSave()}
  >
    <span>Save</span>
  </a>
)

const CancelButton = ({ handleCancel }: Pick<Props, 'handleCancel'>): JSX.Element => (
  <a
    className='bg-white black pv3 ph8 ba br2 normal f6 lh-copy-variant hover-o-90 pointer'
    href={undefined}
    data-event-category='Account'
    data-event-action='Preferences cancel'
    onClick={() => handleCancel()}
  >
    <span>Cancel</span>
  </a>
)

export default ControlButtons
